module.exports = __webpack_public_path__ + "img/Chipsaugen.e6fbb0ba.svg";